export class BAOFaqs extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['faq']
  }

  connectedCallback () {
    super.connectedCallback()

    this.closeAllFaqs = this.closeAllFaqs.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    this.els.faq.elements.forEach(faq => {
      faq.addEventListener('click', this.toggleFaq)
    })
  }

  toggleFaq () {
    const isExpanded = this.getAttribute('aria-expanded') === 'true'

    this.closest('bao-faqs').closeAllFaqs()
    this.setAttribute('aria-expanded', isExpanded ? 'false' : 'true')
  }

  closeAllFaqs () {
    this.els.faq.elements.forEach(faq => {
      faq.setAttribute('aria-expanded', 'false')
    })
  }
}

if (!customElements.get('bao-faqs')) {
  customElements.define('bao-faqs', BAOFaqs)
}
